import styles from '../../../css/Categories.module.css';
import { useEffect, useState, useContext } from 'react';
import Select from '../../../components/Select/index';
import { useDispatch, useSelector } from 'react-redux';
import { addUserToGroup, deleteUser, deleteUserGroup, disableUser } from '../../../redux/reducers/questionReducer';
import { EditContext } from './StaffMgmt';
import { useNavigate } from 'react-router-dom';
import { MenuContext } from '../DashBoard';
import { IoReloadCircleSharp as ReloadIcon } from 'react-icons/io5';
import styled from 'styled-components';
import { Button } from '../../../components/Button';
import Api from '../../../helperFunctions/Api2';
import SideOption from "../../../components/SideOption";
import PageNumber from '../../../components/PageNumber';
import { BiXCircle } from 'react-icons/bi';
import { FaSearch } from 'react-icons/fa';


const ViewUsers = ({ setTitle }) => {

    useEffect(() => {
        setTitle('Users');
    }, [setTitle]);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setEditingUser, setEditUserData } = useContext(EditContext);
    const { selected, changeSelected, setShowLoading, setModalText, setModalToggle } = useContext(MenuContext);

    const [currentUserCategoryArr, setCurrentUserCatergoryArr] = useState([]);
    const institutions = useSelector(state => state.questions.user_institutions)
    const [selInst, setSelInst] = useState({});
    const [users, setUsers] = useState([]);
    // const [currentUsers, setCurrentUsers] = useState([]);
    const [selCat, setSelCat] = useState([]);
    const [reset, setReset] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageNum, setPageNum] = useState(0);
    const [searchText, setSearchText] = useState("");

    const handleDelete = (user) => {
        if (window.confirm('Are you sure you want to delete this user?')) {
            // console.log(user)
            setShowLoading(true);
            Api.PostApi('/institution/delete-user', user, true)
                .then(result => {
                    if (result.isSuccessful) {
                        dispatch(deleteUser(user))
                        setModalText('Deleted user Succesfully');
                    }
                    else{
                        setModalText(result.message);
                    }
                })
                .catch(err => {
                    setModalText('Not Successful, Please try again');
                }).finally(()=>{
                    setModalToggle(true);
                    setShowLoading(false);
                })
        }
    }

    const handleEdit = (user) => {
        setEditUserData(user);
        setEditingUser(true);
        navigate('../add-user')
    }

    const handleEnableDisableUser = (users) => {
        let user = {...users}
        //console.log(user);
        if(window.confirm(`Are you sure you want to ${user.isEnabled==0?'enable':'disable'} this user?`)){
            user.isEnabled = user.isEnabled == 1? 0: 1
            if (!Api.checkNetwork()) return;
                setShowLoading(true);
                Api.PostApi('/institution/enable-disable-user', user , true)
                .then(result => {
                    setShowLoading(false);
                    console.log(result, 'res');
                    if (result.isSuccessful) {
                        setModalText(`User ${!user.isEnabled ? 'Disabled' : 'Enabled'} Successfully`);
                        setModalToggle(true);
                        dispatch(disableUser(user));

                    }
                    else {
                        setModalText(result.message || result[404]);
                        setModalToggle(true);
                    }
                })
                .catch(err => {
                    console.log(err);
                    setShowLoading(false);
                    setModalText('Sorry Check your Network');
                    setModalToggle(true);
                })
            }
        
    }

    const handleReloadFilter = () => {
        setReset(!reset);
    }

    const handleResetPassword = (user) => {
        // console.log(user);
        setModalToggle(true);
        setModalText(<ModalContent data={{ user, setModalText, setModalToggle, setShowLoading }} />);
    }
    const handleAddGroup = (user) => {
        const ModalContent = ()=>{
            const [selGroup, setSelGroup] = useState({});
            const [CategoryArr, setCategoryArr] = useState(currentUserCategoryArr.filter(category => !user.categories.includes(category.id)));

            // useEffect(()=>{
            //     setCategoryArr(currentUserCategoryArr.filter(category => !user.categories.includes(category.id)))
            // },[currentUserCategoryArr])
            
            const handleSubmit = ()=>{
                const payload = {subuser_id: user.id, institution_id: user.institution_id, group_id: selGroup.id};
                console.log(payload);
                if(!payload.group_id){
                    alert('Please select a group');
                    return;
                }
                if (!Api.checkNetwork()) return;
                setShowLoading(true);
                Api.PostApi('/institution/add-user-to-group', payload , true)
                    .then(result => {
                         console.log(result, 'res');
                        setModalText(result.message);  
                        if(result.isSuccessful) {
                            //Update the user group
                            dispatch(addUserToGroup(payload))
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        setModalText('Sorry Check your Network');
                    })
                    .finally(()=>{
                        setShowLoading(false);
                        setModalToggle(true);
                    })
            }
            return<div>
                <label className={styles.label}>
                    <p>Select group</p>
                    <Select onChange={setSelGroup} options={CategoryArr} className={styles.fields} label='name' value='id' reset={reset} />
                </label>
                <Button style={{fontSize: '15px', padding: '10px', minWidth: '100px'}} onClick={handleSubmit}>Save</Button>
            </div>
        }

        // console.log(user);
        setModalToggle(true);
        setModalText(<ModalContent />);
    }

    useEffect(() => {
        let a = selInst ? institutions.filter(institution => institution.id === selInst.id)[0] : {};
        a && setSelInst(a)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [institutions])

    useEffect(() => {
        if (selInst.id && !selCat.id) {
            setUsers(Object.values(selInst.users).sort((a, b) => b.id - a.id).filter(user => Object.values(user).some(value => String(value).toLowerCase().includes(searchText.toLowerCase()))));
        } else if (selInst.id && selCat.id) {
            setUsers(Object.values(selInst.users).filter(user => user.categories.includes(selCat.id)).sort((a, b) => b.id - a.id).filter(user => Object.values(user).some(value => String(value).toLowerCase().includes(searchText.toLowerCase()))));
        }
    }, [selInst, selCat, searchText]);

    useEffect(() => {
        if (selInst.id) {
            handleReloadFilter();
            const cat = [];
            for (let x in selInst.categories) cat.push(selInst.categories[x]);
            setCurrentUserCatergoryArr(Object.values(cat))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selInst]);

    useEffect(() => {
        if (users.length > NO_OF_ITEMS_PER_PAGE) {
            setPageNum((users.length / NO_OF_ITEMS_PER_PAGE) + ((users.length % NO_OF_ITEMS_PER_PAGE) ? 1 : 0))
        }
    }, [users.length]);
    return (
        <>
            <div className={styles.form} >
                <Search>
                    <FaSearch />
                    <input placeholder="Search" type='text' value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                </Search>
                <div className={styles.filterDiv}>
                    <label className={styles.label}>
                        <span>Select institution</span>
                        <Select onChange={setSelInst} options={institutions} className={styles.fields} label='name' value='id' defaultValue={selInst.id && selInst} />
                    </label>
                    <label className={styles.label}>
                        <span>Filter by group</span>
                        <Select onChange={setSelCat} options={currentUserCategoryArr} className={styles.fields} label='name' value='id' reset={reset} />
                    </label>
                    <button onClick={handleReloadFilter} title="Reload filter" style={{ alignSelf: "flex-end", marginBottom: '5px', cursor: "pointer", fontSize: "25px", color: "var(--secondary-color)", oultline: 'none', border: "none", backgroundColor: "transparent" }}><ReloadIcon /></button>
                </div>
                <div className={styles.viewQuestionContainer}>
                    {selInst.id ? users && users.length > 0 ? users.map((user, index) =>
                        <EachUser user={user} key={'user' + index} index={index} className={styles.eachQuestion} selected={selected} changeSelected={changeSelected} resetPassword={() => handleResetPassword(user)} currentPage={currentPage} handleDelete={handleDelete} handleEdit={handleEdit} onEnable={() => handleEnableDisableUser(user)}
                            setModalText={setModalText} setModalToggle={setModalToggle} setShowLoading={setShowLoading} handleAddGroup={handleAddGroup} />)
                        : "No user available!": "Please Select an Institution"}
                </div>
                {users.length > NO_OF_ITEMS_PER_PAGE && <PageNumber currentPage={currentPage} setCurrentPage={setCurrentPage} pageNum={pageNum} />}

            </div>
        </>
    );
};
const NO_OF_ITEMS_PER_PAGE = 30
export default ViewUsers;


const style = {
    display: "inline-block",
    marginLeft: '10px',
    color: 'var(--primary-color)',
}

const Search = styled.div`
padding: 0px 9px;
border: 1px solid var(--border-color);
background-color: white;
max-width: 100%;
width: 100%;
border-radius: 5px;
transition: .2s;
display: flex;
align-items: center;

>input{
    outline: none;
    border: none;
    width: 100%;
    padding-left: 5px;
}
`

const EachUser = ({ resetPassword, className, user, index, selected, changeSelected, handleEdit, handleDelete,
     currentPage, onEnable, setModalText, setModalToggle, setShowLoading, handleAddGroup }) => {
    // console.log(user);
    const [showOption, setShowOption] = useState(false);
    const [seeDetails, setSeeDetails] = useState(false);
    // const [showUser, setShowUser] = useState(false); //
    const [showUser, setShowUser] = useState(true); //
    const dispatch = useDispatch();

    const institutions = useSelector(state => state.questions.user_institutions)
    const institution = institutions.filter(institution => institution.institution_id === user.institution_id || institution.id === user.institution_id)[0]
    // console.log(user, institution)

    const deleteCat = (user, category) => {
        if (user.categories.length < 2) {
            setModalText('User must belong to at least one group');
            setModalToggle(true);
            return
        }
        const payload = {
            institution_id: user.institution_id,
            group_id: category,
            subuser_id: user.id
        }
        //console.log(user, category);
        if (window.confirm('Are you sure you want to remove user from this group?')) {
            if (!Api.checkNetwork()) return;
            setShowLoading(true);
            Api.PostApi('/institution/remove-user-from-group', payload, true)
                .then(result => {
                    if (result.isSuccessful) {
                        dispatch(deleteUserGroup(payload));
                        setModalText('Group removed successfully.');
                    }
                    else {
                        setModalText(result.message);
                    }
                })
                .catch(err => {
                    console.log(err);
                    setModalText('Unsuccessful, Please try again, or Re-Login if problem persists')
                })
                .finally(() => {
                    setModalToggle(true);
                    setShowLoading(false);
                });
        }
    }


    useEffect(() => {

        if (selected === index) {
            setShowOption(true)
        }
        else { setShowOption(false) }

    }, [selected, index])
    useEffect(() => {
        if (index < (currentPage * NO_OF_ITEMS_PER_PAGE) && index >= ((currentPage - 1) * NO_OF_ITEMS_PER_PAGE)) {
            setShowUser(true)
        }
    }, [index, currentPage])
    return (<>
        {showUser && <div className={className} style={{minHeight:'165px'}}>
            <div>
                <div style={{width: '100px', height:'100px', backgroundSize:'contain', backgroundRepeat:'no-repeat', backgroundImage: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAMFBMVEX////Z2dna2tr7+/vz8/Pu7u7W1tbd3d3o6Oj5+fnh4eH19fXw8PDr6+vg4ODk5OSJw/qCAAAFTElEQVR4nO2d25qiMBCECSCIgLz/2y6gowzGETtddIXNf7N7SX2dPqbNZFkikUgkEolEIpFIJBJ7UjRt25Yj4z9NYf01qhRlP1zz3I1UN8b/5Xk99OUBhDb9xc2KvIxir31r/Y1yinLI34pbyHRDF6Ut203yHiKjs2RXb5Z3F1mfrL/5G7rt5lsasrf+7q2U39rvoTHvrL99C8Ug1DdrvDTW3/+RLpfrm2F3x3OAAe9mHKw1/InUA3+R82bHJvSE/sDqjGoCnePM/4oCOSUWmgIpD2qtKtDl1npeCMnzXq7WilZ02gJdxVWlFtr6Jqhc8YJQWFurWlCqn9GJiqhE1U0UD3jKtxPEhEzBBqNvkmit7I5+pngoJDGicjWzhKOyaXECXVVaq5s4AxU6ioYfeEg5EkYDizMTDMe0Rwp07mytD1SSPiEoTrECnTN3xALqhqMjmk9sMG3FQqF5g4Gquh+Yhxpovp8wz/kDWuHFWiE4WRDM3JLC+BXCI425H4LLUoJYihth3DEfZBy/psG2hxQNIlqh/e0FaN79wLx7yq5YgQQdMLgwNU/48IRong7hCdE8Hf4P00TIBfcT+2TxH8y8semCIFmA+yfz3mkCOm0zn7RNtECFFcXiNzSYMoRSbO1tre0GMJhy3OMjgylBVZop7wavyM1vnjJsKOWoSw/f44f/hOQD5jkfrM+ZGxHrhRPWZQ382sI8Y8CvnswbKGj7e8N4yRSdK5JCPMc/peCZ/oRxpNkhWxiPauCX3OZlG/oK2L6mQa8mElyRogXaj2qOv9d2/F2M4/f4WY81onmLn6ELN3sTZlkD1Ge/xz7TSF4U2qSPYlw602M0nhmO6J1Cf6hYMemb0B66WZejHpSzBkOWWKMqkCJLrFGtUAnW2V5RbYYZD6lqrCGMM5nyxoJ12+tHce5Gcn+/RnHuxnF//4JeM0zQ9npRfO2LMRtOqF21UWwk+tBaiGZ50sSDjkBXsR5StWhKGkkndCbgJKMLPyrVN2XV/YPGVIrahCorUsReOBM+PbVW8InQV6MYlhE/ELa6X1G2viuCXjI1v0vbREB5SluQrhBHm5q3XPuNuI3inF34kPXCrH2vF5ErxuKEM5IflkaQCZcIgg3pfO0dgk6RvR5dIahsYqhmFnwfTaOKpJnkEoPzquI9SWH8Co/vh4LhMO8Y2Mvxs8XxM75gcEo9Jn1FUJdG1VqIXgAjvo/xcPzuSbRbE1UwFa1lROWIsjlNRI4onHtHVNUIB6bxzDGktzPxtBfi9a9YYo18NyqWDipgNYriebaPBG0rxHC7FrYYRbwO9UPoQ5HkmxgqTypxS9R4M4rnx04elB7F4pWotSRMW9vo/S6Ic+ekuGj+3uLKd6Xf6cm7QVbAqRrwBpcZMY+28Xhjh/odMMlR7WrkG7S1eeKA6rtpNLXjCXc+Fxpzq36jOLsd9M0a3dkgrrbwZ1t+i7zsO/MvTmj382is+91GHOWw1/FcaXS7GLLZzfv8IsEeWZyuhvLuIusT7LRanc41oNPanPfIfVupcu3T2tmfzjWaBZ1tcHlPVQ0qhiQ035PqGmrIAvR6kB5hHtnsW5mJuQjHj+X+lZmUKhccVoPKM4SxxfqqDuB3v1dGh9yukSq5f8NGjTs8DYxjw3huh4eBsXzwx10GL1j+HOtElB/+oqrftB6AybwV/hsB8EurO/N6I9Ae44A+Wb8MGnWGeMPSjAVzgySnevw0PPShB17uq+PQv9BozLxidWSBN2e0/gYwoxWtPwFOUhg/SWH8JIXxkxTGT1IYP0lh/CSF8ZMUxk9SGD//AIUnaC8kw6bjAAAAAElFTkSuQmCC)'}}>
                    {user.image && <img src={`${Api.img_domain}/upload/subuser/${user.image}`} alt="logo" width={100} height={100}/>}
                </div>
                <div style={{ flexDirection: 'row', alignItems: "flex-start" }}>
                    <span>Name: </span>
                    <span style={style}>{user.lastName} {user.firstName} {user.middleName || ''}</span>
                </div>
            </div>
            <SideOption element={user} index={index} changeSelected={changeSelected} handleDelete={handleDelete} resetPassword={resetPassword} handleEdit={handleEdit} showOption={showOption} onEnable={onEnable} handleAddGroup={handleAddGroup} />
            <button onClick={() => setSeeDetails(!seeDetails)}>{!seeDetails ? 'see more...' : 'see less...'}</button>
            {seeDetails &&
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <div><span>Institution: </span><span style={style}>{institution.name}</span> </div>
                    <div><span>Gender: </span><span style={style}>{user.gender}</span></div>
                    <div><span>Email: </span><span style={style}>{user.email}</span></div>
                    <div><span>Phone Number: </span><span style={style}>{user.phoneNumber}</span></div>
                    <div><span>Date Of Birth: </span><span style={style}>{user.dob || ''}</span></div>
                    <div><span>Is Enabled: </span><span style={style}>{user.isEnabled == 1 ? 'True':'False'}</span></div>
                    <div><span>Groups: </span>
                        <div style={{ margin: '5px' }}>{user.categories.map((category, key) => institution && <EachUserGroup key={key}><span>{institution.categories[category].name}</span>  <i className='tooltip'><BiXCircle className='icon' onClick={() => deleteCat(user, category)} /><span className='tooltiptext'>Remove user from group</span></i></EachUserGroup>)}
                        </div>
                    </div>
                    {user.custom_fields && Object.keys(user.custom_fields).map(key => <div key={key}><span>{String(key).charAt(0).toUpperCase() + String(key).slice(1)}: </span><span style={style}>{user.custom_fields[key]}</span></div>)}

                    {/* {institution.categories.length>0?<ul style={{margin:0,padding:0,maxWidth:'100%'}}><b>Groups: </b>{institution.categories.map((inst,index)=><li style={{width:'100%',listStyle:'',marginLeft:'20px'}} key={'ctgr'+index}>{inst.name}</li>)}</ul>:''} */}
                </div>}

        </div>}
    </>)
}

/*********************************************************************** */

const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap:15px;
    & > *{
        width:100%;
    }
    & > label{
        display: flex;
        flex-direction: column;
        gap:5px;
        align-items:flex-start;
    }
    & > label > input{
        width:100%;
        padding: 10px 15px;
    }
    & > div:first-of-type{
        display: flex;
        gap:20px;
        justify-content: space-between;
    }
    & > div:first-of-type > label{
        display: flex;
        gap:5px;
    }
    & > div:last-of-type{
        display: flex;
        justify-content: space-between;
    }

`
const EachUserGroup = styled.span`
    border:1px solid var(--primary-color);
    color: black;
    padding:3px 10px;
    border-radius: 15px;
    display: inline-block;
    margin:2px;
    cursor:pointer;
    position: relative;

    .icon {
        color: red;
    }
    .tooltip {
        position: relative;
        display: inline;

        .tooltiptext {
            visibility: hidden;
            width: max-content;
            background-color: #fff;
            color: #000;
            border-radius: 6px;
            font-size: 12px;
            box-shadow: rgb(116 178 182 / 50%) 0px 0px 8px, rgba(70, 70, 70, 0.12) 2px 2px 3px;
            padding: 4px;
        
            /* Position the tooltip */
            position: absolute;
            z-index: 1;
            right: 0%;
            top: -32px;

        }
        :hover .tooltiptext{
            visibility: visible;
        }
    }
`
const ModalContent = (props) => {
    const [password, set_password] = useState('');
    const [reset_password, set_reset_password] = useState(false);
    const [send_credential, set_send_credential] = useState(false);
    const { user, setModalToggle, setShowLoading, } = props.data;
    const handleCancel = () => {
        setModalToggle(false);
    }
    const handleSubmit = () => {
        if (password) {
            if (!Api.checkNetwork()) return;
            const obj = {
                id: user.id,
                password,
                send_user_credential: send_credential ? '1' : '0',
                reset_password: reset_password ? '1' : '0',
                institution_id: user.institution_id,
            }
            console.log(obj);
            setShowLoading(true);
            Api.PostApi('/institution/reset-password', obj, true)
                .then(result => {
                    console.log(result);
                    alert(result.message)
                    setShowLoading(false);
                    set_password('');
                    set_reset_password(false);
                    set_send_credential(false);



                }).catch(err => {
                    console.log(err);
                })
        }
    }

    return (
        <ModalContentWrapper>
            <label>
                <span>New Password</span>
                <input placeholder='Enter New Password'
                    value={password}
                    onChange={(e) => set_password(e.target.value)}
                />
            </label>
            <div>
                <label>
                    <input type="checkbox"
                        checked={reset_password}
                        onChange={() => set_reset_password(!reset_password)}
                    />
                    <span>Force password change</span>
                </label>
                <label>
                    <span>Send user credential</span>
                    <input type="checkbox" checked={send_credential}
                        onChange={() => set_send_credential(!send_credential)} />
                </label>
            </div>
            <div>
                <Button onClick={handleCancel} bg="white" border="var(--secondary-color)"
                    color="var(--secondary-color)">
                    Cancel
                </Button>
                <Button onClick={handleSubmit}>
                    Submit
                </Button>


            </div>

        </ModalContentWrapper>
    )
}